import React, { ReactElement } from 'react'

export const mtbRenderIfError = (
    practiceProblemID: string
): ReactElement | null => {
    return (
        <div>Practice problem ID: {practiceProblemID} encountered an error</div>
    )
}
